// @ts-nocheck - form components
import React from 'react';
import KwPanel from '../../common/KwPanel';
import FormSelect from '../../common/FormSelect';
import FormFileUpload from '../../common/FormFileUpload';
import Button from '../../common/Button';
import ConfirmationHeader from '../../common/ConfirmationHeader';
import { useTranslation } from 'react-i18next';

export interface UploadActivatedFormProps {
  register: any;
  errors: any;
  submit: () => void;
  cancel: () => void;
  keyProviders?: any[];
  addFiles: (files: any[]) => void;
  removeFile: (file: any) => void;
  files: any[];
}

function UploadActivatedForm({
  register,
  errors,
  submit,
  cancel,
  keyProviders,
  addFiles,
  removeFile,
  files,
}: UploadActivatedFormProps) {
  const { t } = useTranslation();
  return (
    <>
      <KwPanel className="mb-4">
        <FormSelect
          register={register}
          errorMessage={t('Key provider is required')}
          error={errors.keyProviderId}
          name="keyProviderId"
          label={t('Key provider')}
          required={true}
          placeholder=""
          autoFocus={true}
        >
          <option value="">{t('--- choose ---')}</option>
          {keyProviders
            ? [...keyProviders]
                ?.sort((a: any, b: any) => a.name.localeCompare(b.name))
                .map((x: any) => (
                  <option key={x.id} value={x.id}>
                    {x.name}
                  </option>
                ))
            : ''}
        </FormSelect>
        <FormFileUpload
          name="files"
          required
          errorMessage={t('Required')}
          label={t('Upload key file')}
          error={errors.files}
          addFiles={addFiles}
          removeFile={removeFile}
          files={files}
        />
      </KwPanel>
      <KwPanel className="mb-4">
        <>
          <ConfirmationHeader />
          <p>{t('Are you sure?')}</p>
          <Button
            onClick={submit}
            className="btn btn-primary me-2"
            text={t('Yes, continue')}
          />
          <Button
            onClick={cancel}
            className="btn btn-default"
            text={t('No, cancel')}
          />
        </>
      </KwPanel>
    </>
  );
}
export default UploadActivatedForm;
